export const PACKAGE_DISPLAY_ORDER = ['free', 'basic', 'standard', 'premium', 'enterprise'];

export const PACKAGE_FEATURE_ORDER = [
  'screens',
  'musicPlayers',
  'websites',
  'wifi',
  'menuQrs',
  'productQrs',
  'serviceQrs',
  'infoQrs',
];

export const PACKAGE_FEATURE_LABELS = {
  screens: 'TV screens',
  musicPlayers: 'Music players',
  websites: 'Website',
  wifi: 'Captive Wi-Fi',
  menuQrs: 'Menu QR',
  productQrs: 'Product QR',
  serviceQrs: 'Service QR',
  infoQrs: 'Info QR',
};

export const EMPTY_BILLING_DEFAULTS = {
  screens: 0,
  musicPlayers: 0,
  websites: 0,
  wifi: 0,
  menuQrs: 0,
  productQrs: 0,
  serviceQrs: 0,
  infoQrs: 0,
};

export function isPlainObject(value) {
  return Boolean(value) && typeof value === 'object' && !Array.isArray(value);
}

export function formatVnd(value) {
  const numeric = Number(value);
  if (!Number.isFinite(numeric)) return 'POA';
  return new Intl.NumberFormat('vi-VN').format(Math.round(numeric));
}

export function getOrderedPackageEntries(packageCatalog) {
  const source = isPlainObject(packageCatalog) ? packageCatalog : {};
  return PACKAGE_DISPLAY_ORDER
    .map((key) => source[key])
    .filter((entry) => isPlainObject(entry));
}

export function summarizeIncludedFeatures(pkg) {
  const included = isPlainObject(pkg?.included) ? pkg.included : {};
  return PACKAGE_FEATURE_ORDER
    .map((featureKey) => {
      const rawValue = Number(included[featureKey] || 0);
      if (!rawValue) return null;
      const label = PACKAGE_FEATURE_LABELS[featureKey] || featureKey;
      return `${rawValue} ${label.toLowerCase()}`;
    })
    .filter(Boolean)
    .join(' | ');
}
